export const YN = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
export const YNP = [...YN, { value: 'partial', label: 'Partial' }];
export const YNA = [...YN, { value: 'na', label: 'N/A' }];
/** yes / partly / no answers onto a Yes / No / Partial field. */
export const PARTLY = { yes: 'yes', partly: 'partial', no: 'no' };
// ---------- tests ----------
/** The controls are fully in place. */
export const ctl = (...controls) => ({ from: 'control', controls });
/** The controls are at least partly in place. */
export const ctlPart = (...controls) => ({ from: 'control', controls, yes_at: 0.5 }); // prettier-ignore
export const is = (question, value = 'yes') => ({ from: 'answer', question, op: 'eq', value }); // prettier-ignore
/** A multiple-choice answer includes this option. */
export const has = (question, value) => ({ from: 'answer', question, op: 'contains', value }); // prettier-ignore
export const test = (question, op, value) => ({ from: 'answer', question, op, ...(value === undefined ? {} : { value }) }); // prettier-ignore
export const industry = (...values) => ({ from: 'detail', key: 'industry', op: 'in', value: values }); // prettier-ignore
export const all = (...of) => ({ from: 'all', of });
export const any = (...of) => ({ from: 'any', of });
export const not = (of) => ({ from: 'not', of });
// ---------- sources ----------
export const val = (question, map, path) => ({ from: 'value', question, ...(map ? { map } : {}), ...(path ? { path } : {}) });
export const ctx = (key) => ({ from: 'context', key });
export const DECLARATION = { from: 'declaration' };
export const BROKER = { from: 'broker' };
export const na = (note) => ({ from: 'not_applicable', note });
export const unmapped = (note) => ({ from: 'unmapped', ...(note ? { note } : {}) });
// ---------- fields ----------
export const yn = (key, ref, label, source, more = {}) => ({ key, ref, label, type: 'yes_no', options: YN, source, ...more }); // prettier-ignore
export const ynp = (key, ref, label, source, more = {}) => ({ key, ref, label, type: 'yes_no', options: YNP, source, ...more }); // prettier-ignore
export const yna = (key, ref, label, source, more = {}) => ({ key, ref, label, type: 'yes_no', options: YNA, source, ...more }); // prettier-ignore
export const field = (key, ref, label, type, source, more = {}) => ({ key, ref, label, type, source, ...more }); // prettier-ignore
export const choice = (key, ref, label, options, source, more = {}) => ({ key, ref, label, type: 'choice', options: Object.entries(options).map(([value, label]) => ({ value, label })), source, ...more }); // prettier-ignore
/** A tick-box list: each option is ticked by its own test; an option without one is left for the client. */
export const checklist = (key, ref, label, options, more = {}) => ({ key, ref, label, type: 'multi_choice', options: options.map(([value, label, t]) => (t ? { value, label, test: t } : { value, label })), source: { from: 'checklist' }, ...more }); // prettier-ignore
/** A checklist read from one multiple-choice question whose options carry the same keys. */
export const ticks = (question, options) => options.map(([value, label]) => [value, label, has(question, value)]);
/** Narrative the client writes on the form itself. */
export const note = (key, ref, label, required = false) => ({ key, ref, label, type: 'text', source: unmapped(), required }); // prettier-ignore
/** The director's signature, name and date. */
export const signature = (prefix, ref) => [
    field(`${prefix}_name`, ref, 'Name of the director or officer signing', 'text', DECLARATION),
    field(`${prefix}_signature`, ref, 'Signature', 'text', DECLARATION),
    field(`${prefix}_date`, ref, 'Date signed', 'date', DECLARATION),
];
/** Marks the answers that stop or change a quote (task 91), by field key. */
export const withBlocks = (form, blocks) => ({
    ...form,
    sections: form.sections.map((s) => ({ ...s, fields: s.fields.map((f) => (blocks[f.key] ? { ...f, blocks: blocks[f.key] } : f)) })),
}); // prettier-ignore
// ---------- an insurer's fillable PDF (task 92) ----------
export const cb = (n) => `Check Box ${n}`;
export const tf = (n) => `Text Field ${n}`;
/** A field's boxes by value, numbered as in the PDF ("Check Box n"); a limit's tick box and its "other" box. */
export const boxes = (by, more = {}) => ({
    boxes: Object.fromEntries(Object.entries(by).map(([v, n]) => [v, cb(n)])),
    ...(more.tick === undefined ? {} : { tick: cb(more.tick) }),
    ...(more.other === undefined ? {} : { other: tf(more.other) }),
});
//# sourceMappingURL=helpers.js.map